import React, { useCallback } from 'react';

import { Linking } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectLayoutConfig } from 'store/config/selectors';

import DialogView from 'components/Dialog';

import {
    SCREEN_HELP_BODY_MOBILE,
    SCREEN_HELP_CLOSE_BUTTON,
    SCREEN_HELP_TITLE,
    SCREEN_HELP_WEBSITE_BUTTON,
    SETTING_HELP_EXTERNAL_LINK,
} from '../languagesConst';
import styles from './styles';

const HelpPage = () => {
    const { t } = useTranslation();

    const { primary, background } = useSelector(selectLayoutConfig);

    const handleCloseHelp = useCallback(() => window.history.back(), []);

    const handleOpenHelpWebsite = useCallback(() => {
        Linking.openURL(t(SETTING_HELP_EXTERNAL_LINK))
            .then(handleCloseHelp)
            .catch(handleCloseHelp);
    }, [handleCloseHelp]);

    return (
        <DialogView
            style={styles.dialog}
            title={SCREEN_HELP_TITLE}
            description={SCREEN_HELP_BODY_MOBILE}
            actionButtonTitle={SCREEN_HELP_WEBSITE_BUTTON}
            actionButtonOnPress={handleOpenHelpWebsite}
            actionButtonFillColor={background}
            actionButtonBordered
            cancelButtonTitle={SCREEN_HELP_CLOSE_BUTTON}
            cancelButtonOnPress={handleCloseHelp}
            actionButtonStyle={styles.button}
            cancelButtonFillColor={primary}
            cancelButtonStyle={styles.button}
            cancelButtonTextStyle={styles.buttonText}
            revertButtons
            visible
        />
    );
};

export default HelpPage;
